import { useEffect } from "react";
import digitalMenu from "../assets/images/digital-menu.png";
import styled from "styled-components";
import { up } from "styled-breakpoints";
import FormContainer from "./FormContainer";
import ButtonGroup from "./ButtonGroup";
import ButtonLink from "./ButtonLink";
import FeatureList from "./FeatureList";
import FeatureListItem from "./FeatureListItem";
import { faCheckCircle, faEye, faFilter, faCommentLines } from "pro-light-svg-icons";

const MenuSelectionWrap = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  flex-direction: column;

  ${up("sm")} {
    flex-direction: row;
  }
`;

const MenuImage = styled.img`
  height: auto;
  max-height: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: block;
`;

const MenuImageWrap = styled.div`
  max-height: 100%;

  ${up("sm")} {
    width: 50%;
    height: 375px;
  }

  ${up("md")} {
    height: 400px;
  }

  ${up("lg")} {
    height: 425px;
  }

  ${up("xl")} {
    height: 450px;
  }

  ${up("xxl")} {
    height: 500px;
  }

  ${up("giant")} {
    height: 600px;
  }
`;

function VisualMenuPrompt(props) {
  useEffect(() => {
    props.setHeader("Menu builder");
    props.setSubheader("How would you like customers to view your digital menu?");
    return () => {
      props.setHeader("");
      props.setSubheader("");
    };
  }, [props]);
  return (
    <FormContainer>
      <MenuSelectionWrap>
        <MenuImageWrap>
          <MenuImage src={digitalMenu} />
        </MenuImageWrap>
        <FeatureList>
          <FeatureListItem text="Showcase your delicious offerings with pictures of menu items" icon={faEye} />
          <FeatureListItem text="Change your menu images, prices at the click of a button" icon={faCheckCircle} />
          <FeatureListItem
            text="Customers can search by dietary filters like vegan, vegetarian, gluten free"
            icon={faFilter}
          />
          <FeatureListItem
            text="Private feedback can be submitted by customers that goes directly into your inbox"
            icon={faCommentLines}
          />
        </FeatureList>
      </MenuSelectionWrap>
      <ButtonGroup>
        <ButtonLink to="/menu-builder/visual-menu" text="Create visual menu" />
        <ButtonLink to="/finish" inversed={true} text="Continue with PDF" />
      </ButtonGroup>
    </FormContainer>
  );
}

export default VisualMenuPrompt;
